import { createFormContext, type UseForm } from '@mantine/form';
import type { InvoiceFormFieldValues } from './InvoiceForm.types';

const [InvoiceFormProvider, useInvoiceFormContext, useForm] =
  createFormContext<InvoiceFormFieldValues>();

export { InvoiceFormProvider, useInvoiceFormContext };
export const useInvoiceForm: UseForm<InvoiceFormFieldValues> = useForm;
